import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { getCookie } from 'utils/cookies';
import { PUBLIC_SITE_URL } from 'utils/restapi';
import { setLang } from 'redux/users/actions';

import { Link } from 'react-router-dom';
import LanguageSwitcher from 'components/common/LanguageSwitcher';

import './AuthLayout.css';


const AuthLayout = ({ children, accessToken, className, type, setLang }) => {
  const { t } = useTranslation();

  if (
    type !== 'shopifyOAuth' &&
    type !== 'emailVerification' &&
    (accessToken || getCookie('accessToken'))
  ) {
    window.location.href = '/';
  }

  const calculateClassName = () => {
    let calculatedName = 'auth-layout__component';
    if (className) { calculatedName += ` ${className}`; }
    return calculatedName;
  };

  const renderAuthTopMenu = (type) => {
    let labelText = t("Don't have an account?");
    let btnLink = '/signup';
    let btnText = 'Get Started';
    switch (type) {
      case 'login':
        labelText = t("Don't have an account?");
        btnLink = '/signup';
        btnText = t('Get Started');
        break;
      case 'signup':
        labelText = t('Already have an account?');
        btnLink = '/login';
        btnText = t('Log In');
        break;
      default:
        labelText = t("Don't have an account?");
        btnLink = '/signup';
        btnText = t('Get Started');
    }
    return (
      <div className="auth-layout-top-menu">
        <a
          className="logo"
          href={`${PUBLIC_SITE_URL}`}
        >
          <div className="logo-icon">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 43.9 43.9"><path fill="#48d6d5" className="st0" d="M34.6 9.3l7.1 7.1c2.5 2.5 2.5 6.6 0 9.2-.4.4-.7.8-1.1 1.1-1.3 1.2-3.3 1.2-4.5-.1-.9-.9-1.2-2.2-.8-3.4.2-.5.2-.4.5-1.2.4-.9.2-2.1-.6-2.8l-5.3-5.3-5.3-5.3c-.8-.8-1.9-.9-2.8-.6-.8.3-.7.3-1.2.5-1.1.4-2.5.2-3.4-.8-1.2-1.2-1.3-3.2-.1-4.5l1.1-1.1c2.5-2.5 6.6-2.5 9.2 0l7.2 7.2zM13.9 30.1l-5.3-5.3c-.7-.7-.9-1.8-.6-2.7.1-.3.4-1 .5-1.2.5-1.2.2-2.5-.7-3.5-1.2-1.2-3.2-1.3-4.5-.1l-1.1 1.1c-2.5 2.5-2.5 6.6 0 9.2l7.1 7.1 7.1 7.1c2.5 2.5 6.6 2.5 9.2 0 .4-.4.8-.7 1.1-1.1 1.2-1.3 1.2-3.3-.1-4.5-.9-.9-2.3-1.2-3.5-.7-.3.1-.9.4-1.2.5-.9.3-2 .1-2.7-.6l-5.3-5.3zM33.5 39.1c1.5 1.5 4 1.5 5.5 0s1.5-4 0-5.5l-8.4-8.4c-1.5-1.5-4-1.5-5.5 0s-1.5 4 0 5.5c4.3 4.3 4.1 4 8.4 8.4zM13.3 18.8c1.5 1.5 4 1.5 5.5 0s1.5-4 0-5.5l-8.4-8.4c-1.5-1.5-4-1.5-5.5 0s-1.5 4 0 5.5c4.3 4.3 4 4.1 8.4 8.4z"/></svg>
          </div>
          <div>HeyLink.me</div>
        </a>

        <div className="auth-layout-top-menu-controls">
          <LanguageSwitcher onChange={setLang} />
          <span>{labelText}</span>
          <Link to={btnLink}><span>{btnText}</span></Link>
        </div>
      </div>
    );
  };

  const renderCirclesBackground = () => (
    <Fragment>
      <div className="circle"></div>
      <div className="circle"></div>
      <div className="circle"></div>
    </Fragment>
  );

  return (
    <div className={calculateClassName()}>
      <div className="auth-layout-wrapper">
        {renderCirclesBackground()}
        {renderAuthTopMenu(type)}
        <div className="wrapper">
          {children}
        </div>
        <div className="auth-layout-footer">
          <span>{t("Powered by")}</span>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 32"><path d="M41.889 30.999H3.222C1.442 30.999 0 29.612 0 27.9c0-1.713 1.442-3.1 3.222-3.1H29a15.135 15.135 0 01-2.9-6.199l-5.156-.001c-1.78 0-3.222-1.388-3.222-3.1 0-1.714 1.442-3.101 3.222-3.101 0 0 3.912-.006 5.157-.006A15.146 15.146 0 0128.99 6.21c-2.882-.011-16.101-.011-16.101-.011-1.781 0-3.223-1.387-3.223-3.1C9.666 1.387 11.108 0 12.889 0h29C50.787 0 58 6.939 58 15.5s-7.213 15.499-16.111 15.499zm0-24.8c-5.34 0-9.667 4.163-9.667 9.301 0 5.137 4.327 9.3 9.667 9.3 5.339 0 9.666-4.163 9.666-9.3 0-5.138-4.327-9.301-9.666-9.301z" /></svg>
            <span>Persollo</span>
          </div>
        </div>
      </div>
    </div>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  accessToken: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  setLang: PropTypes.func.isRequired,
};

AuthLayout.defaultProps = {
  accessToken: null,
  className: null,
  type: null,
};

const mapStateToProps = state => (
  {
    accessToken: state.usersReducer.accessToken,
  }
);

export default connect(
  mapStateToProps,
  {
    setLang,
  },
)(AuthLayout);
